export default {
  'alert:btn': 'OK',
  'alert:no-iin-title': 'Балаңыздың ЖСН жоқ болса, тіркелген мекенжайыңыз бойынша ХҚКО-ға жүгініңіз',
  'alert:no-iin-text': 'Балаға ЖСН алу жөнінде толығырақ <a href="https://egov.kz/cms/ru/articles/child/2Fiin_of_child" target="_blank">egov.kz</a> сайтынан біле аласыз.',
  'alert:your-iin-title': 'Өз ЖСН-іңізді жазып қойдыңыз.',
  'alert:your-iin-text': 'Балаңыздың ЖСН жазыңыз',
  'alert:your-phone-title': '{0}, сіз өз телефон нөміріңізді көрсетіпсіз',
  'alert:your-phone-text': '{0} телефон нөмірін көрсетіңіз',
  'alert:iin-exist-title': 'Бұл ЖСН өзге клиенттікі.',
  'alert:iin-exist-text': 'Балаңыздың ЖСН жазыңыз',
  'alert:phone-exist-title': 'Бұл телефон нөмірі өзге клиенттікі.',
  'alert:phone-exist-text': 'Балаңыздың телефон нөмірін жазыңыз',
  'alert:validation-title': 'Балаңыздың деректерін жазыңыз',
  'alert:validation-text': 'сонда Kaspi Gold ресімдеуге өтініш құра аламыз',
  'alert:clear': 'Түсінікті',
  'alert:min-age': 'Балаға Kaspi Gold картасын</br> 6 жастан асқан соң ғана аштыруға болады </br>',
  'alert:max-age': '{0} Kaspi Gold картасын </br> Kaspi.kz қосымшасынан өз бетімен</br>аштырып алуына болады',
  'alert:has-gold': '{0} бұрыннан Kaspi Gold картасының иесі',
  'alert:re-release': 'Карта алу',
  'alert:cancel': 'Бас тарту'
}
